// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.avo__tooltip {
  position: relative;
  font-size: 13px;
  font-family: "OpenSans-Regular";
  white-space: pre-wrap;
}
.avo__tooltip:hover {
  cursor: default;
}
.avo__tooltip:before {
  position: absolute;
  z-index: 2;
  display: none;
  padding: 10px;
  width: max-content;
  max-width: 35vw;
  border-radius: 7px;
  background-color: #101307;
  color: #ffffff;
  content: attr(data-title);
}
.avo__tooltip:after {
  position: absolute;
  z-index: 1;
  display: none;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  content: "";
}
.avo__tooltip.hide:hover:before, .avo__tooltip.hide:hover:after {
  display: none;
}
.avo__tooltip:hover:before, .avo__tooltip:hover:after {
  display: inline-block;
}
.avo__tooltip.top:before, .avo__tooltip.bottom:before {
  left: 50%;
  transform: translateX(-50%);
}
.avo__tooltip.top:before {
  bottom: calc(100% + 5px);
}
.avo__tooltip.bottom:before {
  top: calc(100% + 5px);
}
.avo__tooltip.left:before, .avo__tooltip.right:before {
  top: 50%;
  transform: translateY(-50%);
}
.avo__tooltip.left:before {
  right: calc(100% + 5px);
}
.avo__tooltip.right:before {
  left: calc(100% + 5px);
}
.avo__tooltip.top:after, .avo__tooltip.bottom:after {
  left: 50%;
  transform: translateX(-50%);
}
.avo__tooltip.top:after {
  bottom: 100%;
  border-bottom-width: 0;
  border-top-color: #101307;
}
.avo__tooltip.bottom:after {
  top: 100%;
  border-top-width: 0;
  border-bottom-color: #101307;
}
.avo__tooltip.left:after, .avo__tooltip.right:after {
  top: 50%;
  transform: translateY(-50%);
}
.avo__tooltip.left:after {
  right: 100%;
  border-right-width: 0;
  border-left-color: #101307;
}
.avo__tooltip.right:after {
  left: 100%;
  border-left-width: 0;
  border-right-color: #101307;
}`, "",{"version":3,"sources":["webpack://./src/components/commons/tooltip/tooltip.scss","webpack://./src/styles/_color.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,qBAAA;AADF;AAGE;EACE,eAAA;AADJ;AAIE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,cCrBI;EDsBJ,yBAAA;AAFJ;AAKE;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;EACA,WAAA;AAHJ;AAME;EACE,aAAA;AAJJ;AAOE;EACE,qBAAA;AALJ;AAQE;EACE,SAAA;EACA,2BAAA;AANJ;AASE;EACE,wBAAA;AAPJ;AAUE;EACE,qBAAA;AARJ;AAWE;EACE,QAAA;EACA,2BAAA;AATJ;AAYE;EACE,uBAAA;AAVJ;AAaE;EACE,sBAAA;AAXJ;AAcE;EACE,SAAA;EACA,2BAAA;AAZJ;AAeE;EACE,YAAA;EACA,sBAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,SAAA;EACA,mBAAA;EACA,4BAAA;AAdJ;AAiBE;EACE,QAAA;EACA,2BAAA;AAfJ;AAkBE;EACE,WAAA;EACA,qBAAA;EACA,0BAAA;AAhBJ;AAmBE;EACE,UAAA;EACA,oBAAA;EACA,2BAAA;AAjBJ","sourcesContent":["@import '../../../styles/color';\n\n.avo__tooltip {\n  position: relative;\n  font-size: 13px;\n  font-family: 'OpenSans-Regular';\n  white-space: pre-wrap;\n\n  &:hover {\n    cursor: default;\n  }\n\n  &:before {\n    position: absolute;\n    z-index: 2;\n    display: none;\n    padding: 10px;\n    width: max-content;\n    max-width: 35vw;\n    border-radius: 7px;\n    background-color: #101307;\n    color: $white;\n    content: attr(data-title);\n  }\n\n  &:after {\n    position: absolute;\n    z-index: 1;\n    display: none;\n    width: 0;\n    height: 0;\n    border: 5px solid transparent;\n    content: \"\";\n  }\n\n  &.hide:hover:before, &.hide:hover:after {\n    display: none;\n  }\n\n  &:hover:before, &:hover:after {\n    display: inline-block;\n  }\n\n  &.top:before, &.bottom:before {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  &.top:before {\n    bottom: calc(100% + 5px);\n  }\n\n  &.bottom:before {\n    top: calc(100% + 5px);\n  }\n\n  &.left:before, &.right:before {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  &.left:before {\n    right: calc(100% + 5px);\n  }\n\n  &.right:before {\n    left: calc(100% + 5px);\n  }\n\n  &.top:after, &.bottom:after {\n    left: 50%;\n    transform: translateX(-50%);\n  }\n\n  &.top:after {\n    bottom: 100%;\n    border-bottom-width: 0;\n    border-top-color: #101307;\n  }\n\n  &.bottom:after {\n    top: 100%;\n    border-top-width: 0;\n    border-bottom-color: #101307;\n  }\n\n  &.left:after, &.right:after {\n    top: 50%;\n    transform: translateY(-50%);\n  }\n\n  &.left:after {\n    right: 100%;\n    border-right-width: 0;\n    border-left-color: #101307;\n  }\n\n  &.right:after {\n    left: 100%;\n    border-left-width: 0;\n    border-right-color: #101307;\n  }\n}\n","$white: #ffffff;\n$black: #000000;\n$primary: #116584;\n$red: #f04438;\n\n$neutral-10: #f9fafb;\n$neutral-20: #ebf0f6;\n$neutral-30: #cdd5df;\n$neutral-40: #b6bfcb;\n$neutral-50: #97a2b6;\n$neutral-60: #788192;\n$neutral-70: #4a5467;\n$neutral-80: #101728;\n$neutral-90: #0a0a0a;\n\n$primary-10: #eef7fa;\n$primary-20: #ddf6ff;\n$primary-30: #a6e7ff;\n$primary-40: #2d96be;\n$primary-50: #116584;\n$primary-60: #07506d;\n$primary-70: #062d3d;\n$primary-80: #052431;\n$primary-90: #041b25;\n$primary-100: #021218;\n$primary-shadow: #073649;\n\n$red-10: #fef3f2;\n$red-20: #fee4e2;\n$red-30: #fecdca;\n$red-40: #fda29b;\n$red-50: #f97066;\n$red-60: #f04438;\n$red-70: #d92d20;\n$red-80: #b42318;\n$red-90: #912018;\n$red-100: #570f04;\n$red-shadow: #f0443840;\n\n$green-10: #F1F8F6;\n$green-20: #CFE6E0;\n$green-30: #B0D6CB;\n$green-40: #82C0AD;\n$green-50: #39987C;\n$green-60: #118462;\n$green-70: #0E6E52;\n$green-80: #0B5841;\n$green-90: #043B2B;\n$green-100: #031A14;\n$green-shadow: #11846240;\n\n$orange-10: #FFF6ED;\n$orange-20: #FFEACA;\n$orange-30: #FEB273;\n$orange-40: #FD853A;\n$orange-50: #FB6514;\n$orange-60: #EC4A0A;\n$orange-70: #C4320A;\n$orange-80: #9C2A10;\n$orange-90: #7E2410;\n$orange-100: #2D160C;\n$orange-shadow: #EC4A0A40;\n\n$blue-10: #F5FAFF;\n$blue-20: #DEEFFF;\n$blue-30: #84CAFF;\n$blue-40: #53B1FD;\n$blue-50: #2E90FA;\n$blue-60: #1570EF;\n$blue-70: #175CD3;\n$blue-80: #1849A9;\n$blue-90: #194185;\n$blue-100: #06214F;\n$blue-shadow: #1570EF40;\n\n$purple-10: #F4EBFF;\n$purple-20: #E9D7FE;\n$purple-30: #D6BBFB;\n$purple-40: #B692F6;\n$purple-50: #9E77ED;\n$purple-60: #7F56D9;\n$purple-70: #6941C6;\n$purple-80: #53389E;\n$purple-90: #42307D;\n$purple-100: #180947;\n$purple-shadow: #6D118440;\n\n$pink-10: #FDF2FA;\n$pink-20: #FFDEF5;\n$pink-30: #FAA7E0;\n$pink-40: #F670C7;\n$pink-50: #EE46BC;\n$pink-60: #DD2590;\n$pink-70: #C11574;\n$pink-80: #9E165F;\n$pink-90: #851651;\n$pink-100: #851651;\n$pink-shadow: #DD259040;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
